import React from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { IDENTITY_TYPE_LABEL, LIMITS } from '../constants';
import { SearchRequest } from '../types';
import useStyles from '../useStyles';
import { truncate } from '../utils/format';

interface IContextBarProps {
	context: SearchRequest;
	onEdit: () => void;
	// set while an export is being audited: abandoning it would log an export that never downloads
	isEditDisabled: boolean;
}

const ContextBar: React.FC<IContextBarProps> = ({ context, onEdit, isEditDisabled }) => {
	const { classes } = useStyles();
	return (
		<section aria-label='Request context' className={classes.contextBar}>
			<div className={classes.contextItem}>
				<span className={classes.contextLabel}>Ticket ID</span>
				<span className={classes.mono}>{context.ticketId}</span>
			</div>
			<div className={classes.contextItem}>
				<span className={classes.contextLabel}>Reason</span>
				<span className={classes.contextReason} title={context.reason}>
					{truncate(context.reason, LIMITS.REASON_PREVIEW)}
				</span>
			</div>
			<div className={classes.contextItem}>
				<span className={classes.contextLabel}>Identifier type</span>
				<span>{IDENTITY_TYPE_LABEL[context.identityType] || context.identityType}</span>
			</div>
			<div className={classes.contextSpacer} />
			<Button kind={KIND.secondary} size={SIZE.compact} disabled={isEditDisabled} onClick={onEdit}>
				Edit
			</Button>
		</section>
	);
};

export default ContextBar;
